import React from 'react';
import { Link } from 'react-router-dom';
import { POPULAR_KEYWORDS } from '../../data/keywords';

const PopularSearches = ({ title = "Popular Searches" }) => {
    return (
        <div className="popular-searches mt-5 p-4 ">
            <h5 className="fw-bold mb-3 text-start">{title}</h5>
            <div className="d-flex flex-wrap gap-2">
                {POPULAR_KEYWORDS.map((item, index) => (
                    <Link
                        key={index}
                        to={`/itemlist?q=${encodeURIComponent(item.term)}`}
                        className="badge bg-white text-dark border text-decoration-none px-3 py-2 hover-shadow transition-all"
                        style={{ fontSize: '0.9rem' }}
                    >
                        {item.term}
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default PopularSearches;
